/** A browser-native, transient guard for matches with meaningful departure. */
export class SessionNavigationGuard {
  #active = false;
  setActive(active: boolean): void {
    if (this.#active === active) return;
    this.#active = active;
    if (active) window.addEventListener('beforeunload', this.#beforeUnload);
    else window.removeEventListener('beforeunload', this.#beforeUnload);
  }
  dispose(): void { this.setActive(false); }
  #beforeUnload = (event: BeforeUnloadEvent): void => {
    event.preventDefault();
    event.returnValue = '';
  };
}
